import { useEffect, useState } from 'react'
import { Tipp } from './Hinweis'

export type Thema = 'system' | 'hell' | 'dunkel'

/**
 * Hell, dunkel oder wie das System.
 *
 * "System" ist die Voreinstellung und setzt kein Merkmal - dann
 * entscheidet prefers-color-scheme. Eine ausdrueckliche Wahl setzt
 * data-theme und gewinnt in beide Richtungen.
 */
export function useThema(): [Thema, (t: Thema) => void] {
  const [thema, setThema] = useState<Thema>(() => {
    try {
      const g = localStorage.getItem('gastro-thema')
      if (g === 'hell' || g === 'dunkel') return g
    } catch { /* Speicher gesperrt - dann eben System */ }
    return 'system'
  })
  useEffect(() => {
    const w = document.documentElement
    if (thema === 'system') delete w.dataset.theme
    else w.dataset.theme = thema === 'hell' ? 'light' : 'dark'
    try { localStorage.setItem('gastro-thema', thema) } catch { /* egal */ }
  }, [thema])
  return [thema, setThema]
}

export function ThemaSchalter({ thema, setThema }: { thema: Thema; setThema: (t: Thema) => void }) {
  const felder: { wert: Thema; zeichen: string; name: string }[] = [
    { wert: 'hell', zeichen: '☀', name: 'Hell' },
    { wert: 'system', zeichen: '◐', name: 'System' },
    { wert: 'dunkel', zeichen: '☾', name: 'Dunkel' },
  ]
  return (
    <div className="knopfleiste" role="group" aria-label="Darstellung">
      {felder.map((f) => (
        <Tipp key={f.wert} text={f.name}>
          <button aria-pressed={thema === f.wert}
                  onClick={() => setThema(f.wert)}>
            <span aria-hidden="true">{f.zeichen}</span>
            <span className="knopf-wort">{f.name}</span>
          </button>
        </Tipp>
      ))}
    </div>
  )
}
